import { TrashIcon } from "@heroicons/react/24/outline";
import { useFormContext } from "react-hook-form";
import { IBroadcastFormShape } from "../../../interfaces/esim/BroadcastNotifications.types";
import { appLanguages } from "../../../utils/esim/broadcastStatus";
import IconBtn from "../../ui/IconBtn";
import Input from "../../ui/input/Input";
import { selectClassName } from "./broadcastFormClasses";

interface BroadcastTranslationRowProps {
  index: number;
  usedLanguages: string[];
  sourceLanguage: string;
  onRemove: () => void;
}

const BroadcastTranslationRow: React.FC<BroadcastTranslationRowProps> = ({
  index,
  usedLanguages,
  sourceLanguage,
  onRemove
}) => {
  const {
    register,
    formState: { errors }
  } = useFormContext<IBroadcastFormShape>();

  return (
    <div className="rounded-lg border p-3 mb-3 bg-gray-50">
      <div className="flex items-center justify-between mb-2">
        <div className="w-64">
          <select
            {...register(`translations.${index}.applicationLanguage`)}
            className={selectClassName}
          >
            <option value="">Zgjidh gjuhën</option>
            {appLanguages.map((lang) => (
              <option
                key={lang.code}
                value={lang.code}
                disabled={
                  // Already taken by another row, or it is the main message's own language —
                  // picking that would duplicate the main message as a translation.
                  lang.code === sourceLanguage ||
                  (usedLanguages.includes(lang.code) &&
                    usedLanguages[index] !== lang.code)
                }
              >
                {lang.label}
              </option>
            ))}
          </select>
          {errors.translations?.[index]?.applicationLanguage && (
            <p className="text-xs text-warning mt-1">
              {errors.translations[index]?.applicationLanguage?.message}
            </p>
          )}
        </div>
        <span title="Hiq përkthimin">
          <IconBtn className="w-6 h-6 text-neutral" onClick={onRemove}>
            <TrashIcon className="w-4 h-4" />
          </IconBtn>
        </span>
      </div>
      <Input
        {...register(`translations.${index}.title`)}
        label="Titulli"
        error={errors.translations?.[index]?.title?.message}
      />
      <Input
        {...register(`translations.${index}.body`)}
        label="Përmbajtja"
        error={errors.translations?.[index]?.body?.message}
      />
    </div>
  );
};

export default BroadcastTranslationRow;
